import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Modal, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { showErrorNotification, showSuccessNotification } from 'libs/util/src/lib/notifications';

import { importFile, cleanImportLayout } from '../header-actions';
import { getExportLoading, getImportLoading } from '../header-reducer';
import { fetchImportDetails } from '../../import/import-actions';
import { getTotal } from '../../import/import-reducer';

const { Dragger } = Upload;

export const UploadModal = ({ visible, onCancel, type }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isExportLoading = useSelector(getExportLoading);
  const isImportLoading = useSelector(getImportLoading);
  const searchPayload = {
    page: 0,
    size: 15,
  };
  let totalCount = useSelector(getTotal);

  const handleChanges = (options) => {
    const path = pathname.includes('import') ? 'import' : 'locations';
    if (options?.file?.status !== 'removed') {
      dispatch(importFile({ path: path, file: options.file }));
    }
  };

  useEffect(() => {
    if (totalCount === 0 && type == 'Import Fie') {
      onCancel();
      showSuccessNotification('File uploaded successfully');
      dispatch(cleanImportLayout());
      dispatch(fetchImportDetails(searchPayload));
    }
  }, [totalCount]);

  return (
    <StyledImportModal title='Upload Bulk Update' open={visible} footer={null} onCancel={onCancel}>
      <Dragger
        disabled={isImportLoading || isExportLoading}
        accept={'.xlsx'}
        maxCount={1}
        beforeUpload={() => false}
        fileList={[]}
        onChange={handleChanges}
      >
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        {isImportLoading ? (
          <p className='ant-upload-hint'>Processing...</p>
        ) : (
          <>
            <p className='ant-upload-text'>Click or drag file to this area to upload</p>
            <p className='ant-upload-hint'>Support for a single file only</p>
          </>
        )}
      </Dragger>
    </StyledImportModal>
  );
};

const StyledImportModal = styled(Modal)`
  .ant-modal-content {
    width: initial;
  }
`;
